import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Col,
  Container,
  Row,
  Card,
  Table,
  Input,
  Label,
  FormGroup,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import "simplebar/dist/simplebar.min.css";
import { get, post } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import caldropdown from "../../../assets/images/cal-dropdown.svg";
import moreIcon from "../../../assets/images/more.png";
import Placeholder from "../../../assets/images/Placeholder.gif";
import { toast, Bounce } from "react-toastify";
const RedeemPasses = () => {
  document.title = "Redeem Passes Listing | Elevated - Admin Dashboard";
  const [dropdownOpen, setDropdownOpen] = useState({
    dateRange: false,
  });
  const navigate = useNavigate();
  const { currentUser } = useSelector((state) => state.auth);
  const [gymData, setGymData] = useState([]);
  const [code, setCode] = useState("");
  const [redeemData, setRedeemData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState("");
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const toggle = () => setModal(!modal);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startSearchDate, setStartSearchDate] = useState("");
  const [endSearchDate, setEndSearchDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState("");
  const [itemPerPage, setItemPerPage] = useState("");

  const itemsPerPage = 6;
  const gymIds = async () => {
    const resp = await get(
      `${endpoints.gym}/admin?userId=${currentUser.id}&limit=50`
    );
    if (resp?.data?.success) {
      setGymData(resp.data.data);
      setSeletedGymId(resp?.data?.data[0]?._id);
    }
  };
  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    redeemPasses("");
    setEndSearchDate("");
    setStartSearchDate("");
  };
  useEffect(() => {
    gymIds();
  }, []);
  const redeemPasses = async (page) => {
    if (seletedGymId != "") {
      const resp = await get(
        `${endpoints.getRedeemPass}?userId=${currentUser.id}&gymId=${seletedGymId}&startDate=${startSearchDate}&endDate=${endSearchDate}&limit=${itemsPerPage}&page=${page}`
      );
      if (resp?.data?.success) {
        setRedeemData(resp.data.data);

        setTotalPages(resp.data?.totalPages || 1);
        setItemPerPage(resp.data?.data?.length || 0);
        setTotalItems(resp.data?.totalCount || 0);
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (startSearchDate != "" && endSearchDate != "") {
      redeemPasses(1);
    } else {
      redeemPasses(1);
    }
  }, [startSearchDate, endSearchDate]);

  useEffect(() => {
    if (seletedGymId) {
      redeemPasses(currentPage);
    }
  }, [seletedGymId, currentPage]);

  const redeemPassHandle = async () => {
    if (!code) {
      setError("Please enter a pass code.");
      return;
    }
    if (!seletedGymId) {
      setError("Please select a gym.");
      return;
    }

    setIsLoading(true);
    setError(null);
    try {
      const response = await post(`${endpoints.redeem}`, {
        code,
        gymId: seletedGymId,
      });
      if (response?.data?.success) {
        toast.success("Pass Redeemed Successfully!", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        setCode("");
      } else if (response?.data?.message === "Pass has been used up") {
        toast.error("Pass Limit Reached! You’ve already used this pass.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      } else {
        toast.error("Invalid Pass Code! Please check the code and try again.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      }
    } catch (err) {
      setError(err?.message || "Failed to redeem pass.");
    } finally {
      redeemPasses(1);
      setCurrentPage(1);
      setIsLoading(false);
    }
  };

  const toggleDropdown = (seletedGymId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [seletedGymId]: !prevState[seletedGymId],
    }));
  };
  function formatDate(date) {
    try {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date)
        .toLocaleDateString("en-CA", options)
        .replace(/\//g, "-");
    } catch (err) {
      console.error("Error", err);
    }
  }
  const handleRedeemDetail = async (id) => {
    try {
      const response = await get(`${endpoints.redeemDetail}?gymId=${id}`);
      navigate(`/redeem-pass-detail`, { state: { redeemData: response.data } });
    } catch (error) {
      console.error("Error fetching pass details:", error);
    }
  };
  const handleRedeemInvoice = async (id) => {
    try {
      const response = await get(`${endpoints.redeemDetail}?gymId=${id}`);
      navigate(`/redeem-invoice`, { state: { redeemData: response.data } });
    } catch (error) {
      console.error("Error fetching pass details:", error);
    }
  };
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };
  const formatNumber = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(2) + "B";
    } else if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "K";
    }
    return num.toFixed(2);
  };
  return (
    <Container fluid>
      <Row>
        <Col>
          <Card className="rounded-4 p-4">
            <Row className="justify-content-center align-items-start">
              <Col xs={12}>
                <div className="d-flex flex-column justify-content-center">
                  {/* Header Section */}
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2 mb-3">
                    {/* Title */}
                    <h3 className="primary-black ff-sora font-size-20 fw-bold mb-2 mb-md-0 w-75">
                      Redeem Passes
                    </h3>

                    {/* Filters Section */}
                    <div className="d-flex flex-column flex-sm-row align-items-center gap-2 w-100 w-md-auto">
                      {/* Date Range Dropdown */}
                      <div className="me-2 w-100 w-sm-auto">
                        <Dropdown
                          isOpen={dropdownOpen.dateRange}
                          toggle={() => toggleDropdown("dateRange")}
                          className="w-100 w-md-auto"
                        >
                          <DropdownToggle
                            caret
                            className="filter-btn d-flex ff-sora justify-content-between align-items-center  w-100 w-xs-auto"
                          >
                            <span className="fw-normal ff-sora secondary-black  w-100 w-xs-auto">
                              Date Range
                            </span>
                            <img
                              src={caldropdown}
                              alt="Calendar Dropdown"
                              className="ms-2"
                            />
                          </DropdownToggle>
                          <DropdownMenu style={{ zIndex: 2 }} className="p-3">
                            <div className="d-flex flex-column">
                              <span className="mb-2 fw-normal ff-sora secondary-black font-size-14">
                                Select
                              </span>
                              <DatePicker
                                selected={startDate}
                                onChange={(date) => {
                                  setStartDate(date);
                                  let temp = formatDate(date);
                                  setStartSearchDate(temp);
                                }}
                                dateFormat="yyyy/MM/dd"
                                className="form-control fw-normal ff-sora secondary-black font-size-14 mb-3"
                                placeholderText="Start Date"
                              />
                              <DatePicker
                                selected={endDate}
                                onChange={(date) => {
                                  setEndDate(date);
                                  let temp = formatDate(date);
                                  setEndSearchDate(temp);
                                }}
                                dateFormat="yyyy/MM/dd"
                                className="form-control fw-normal ff-sora secondary-black font-size-14"
                                placeholderText="End Date"
                              />
                            </div>
                            <button
                              type="button"
                              onClick={handleClearDates}
                              className="btn btn-link text-danger fw-normal ff-sora font-size-12 mt-2 p-0"
                            >
                              Clear
                            </button>
                          </DropdownMenu>
                        </Dropdown>
                      </div>

                      {/* Gym Select Input */}
                      <Input
                        id="toggler"
                        name="select"
                        style={{
                          width: "100%",
                          maxWidth: "420px",
                          height: "48px",
                          border: "3.5px solid #f5f5f5",
                        }}
                        type="select"
                        className="fw-normal rounded-5 ff-sora px-4 font-size-14"
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          setSeletedGymId(selectedValue);
                        }}
                      >
                        {gymData.map((item, index) => (
                          <option
                            className="fw-normal ff-sora font-size-14"
                            key={index}
                            value={item?._id}
                          >
                            {item.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                  </div>

                  {/* Pass Code Input and Redeem Button */}
                  <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2 my-2 w-100">
                    <FormGroup className="w-100 d-flex align-items-center justify-content-start">
                      <Input
                        value={code}
                        onChange={(e) => setCode(e.target.value.trim())}
                        style={{
                          width: "100%",
                          maxWidth: "420px",
                          height: "56px",
                          backgroundColor: "#F8F9FA",
                        }}
                        id="passSearch"
                        name="search"
                        placeholder="Enter Pass Code"
                        type="search"
                        className="fw-normal rounded-5 ff-sora px-4 font-size-14 me-2 border-none"
                      />
                      <Button
                        onClick={redeemPassHandle}
                        className="rounded-5 rounded-pill"
                        outline
                        disabled={isLoading}
                      >
                        {isLoading ? <Spinner size="sm" /> : "Redeem"}
                      </Button>
                    </FormGroup>
                  </div>

                  {/* Error Message */}
                  <p className="text-danger">{error}</p>

                  {/* Table Section */}
                  <div
                    className="table-responsive hide-scrollbar rounded-4"
                    style={{
                      height: redeemData?.length > 0 ? "500px" : "auto",
                    }}
                  >
                    <Table
                      hover
                      className="table-borderless table-centered table-nowrap"
                    >
                      <thead>
                        <tr>
                          <th className="primary-black fw-bold ff-sora font-size-14">
                            Pass ID
                          </th>
                          <th className="primary-black fw-bold ff-sora font-size-14">
                            User Name
                          </th>
                          <th className="primary-black fw-bold ff-sora font-size-14">
                            Pass Title
                          </th>
                          <th className="primary-black fw-bold ff-sora font-size-14">
                            Pass Type
                          </th>
                          <th className="primary-black fw-bold ff-sora font-size-14">
                            Pass Price
                          </th>
                          <th className="primary-black fw-bold ff-sora font-size-14">
                            Redeem On
                          </th>
                          <th className="primary-black fw-bold ff-sora font-size-14">
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={8} className="text-center">
                              <div className="d-flex justify-content-center align-items-center">
                                <div
                                  className="spinner-border"
                                  style={{
                                    width: "3rem",
                                    height: "3rem",
                                    color: "#3BABA6",
                                  }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : redeemData.length === 0 ? (
                          <></>
                        ) : (
                          redeemData.map((pass, index) => (
                            <tr key={pass._id}>
                              <td className="fw-normal ff-sora secondary-black font-size-14">
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td className="fw-normal text-capitalize ff-sora secondary-black font-size-14">
                                {`${pass?.userDetail.firstName} ${
                                  pass?.userDetail.lastName
                                    ? ` ${pass?.userDetail.lastName}`
                                    : ""
                                }`}
                              </td>
                              <td className="fw-normal ff-sora text-capitalize secondary-black font-size-14">
                                {pass.passDetail.name}
                              </td>
                              <td className="fw-normal ff-sora text-capitalize secondary-black font-size-14">
                                {pass.passDetail.duration === "oneweek"
                                  ? "One Week"
                                  : pass.passDetail.duration === "oneday"
                                  ? "One Day"
                                  : pass.passDetail.duration === "onemonth" &&
                                    "One Month"}
                              </td>
                              <td className="fw-normal ff-sora secondary-black font-size-14">
                                ${formatNumber(pass.passPrice)}
                              </td>
                              <td className="fw-normal ff-sora secondary-black font-size-14">
                                {pass.createdAt
                                  ? new Date(
                                      pass.createdAt
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </td>
                              <td>
                                <Dropdown
                                  isOpen={dropdownOpen[pass._id]}
                                  toggle={() => toggleDropdown(pass._id)}
                                  direction="down"
                                >
                                  <DropdownToggle
                                    tag="button"
                                    className="btn btn-link p-0"
                                  >
                                    <img src={moreIcon} alt="More options" />
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleRedeemInvoice(pass._id)
                                      }
                                    >
                                      Invoice
                                    </DropdownItem>
                                    <DropdownItem
                                      className="fw-normal ff-sora secondary-black font-size-14"
                                      onClick={() =>
                                        handleRedeemDetail(pass._id)
                                      }
                                    >
                                      Redeem Pass Detail
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                      {!loading && redeemData.length === 0 && (
                        <div className="d-flex flex-column align-items-center justify-content-center vh-50">
                          <img
                            src={Placeholder}
                            alt="No record placeholder"
                            className="object-fit-contain img-fluid h-25 w-25 rounded-3 mb-3"
                          />
                          <p className="mt-3 ff-sora font-size-16 fw-normal">
                            No Record Found!
                          </p>
                        </div>
                      )}
                    </Table>
                  </div>
                </div>
              </Col>
            </Row>
            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader
                toggle={toggle}
                className="fw-bold ff-sora font-size-14 border-0 mb-0 pb-2"
                style={{ fontWeight: "bold" }}
              >
                Congratulations! <br />
                You have redeemed your pass!
              </ModalHeader>
              <ModalBody className="fw-normal ff-sora font-size-14 pt-0">
                Borem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                vulputate libero et velit interdum, ac aliquet odio mattis.
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos. Curabitur tempus urna at turpis
                condimentum lobortis. Ut commodo efficitur neque.
              </ModalBody>
            </Modal>
          </Card>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: "40px",
              position: "sticky",
              bottom: "0",
              zIndex: "10",
              backgroundColor: "#f5f5f5",
            }}
          >
            <div>
              <span className="font-size-14 mb-1 fw-normal ff-sora secondary-black">
                {`Showing ${Math.min(
                  (currentPage - 1) * itemsPerPage + itemPerPage
                )} of ${totalItems}`}
              </span>
            </div>
            <div className="d-flex justify-content-center">
              <Button
                style={{
                  width: "40px",
                  height: "40px",
                  color: "#1f1f1f",
                  borderWidth: "1px",
                  borderColor: currentPage === 1 ? "#f5f5f5" : "#1f1f1f",
                  background: "#f5f5f5",
                  borderRadius: "80px",
                }}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &lt;
              </Button>
              {[...Array(totalPages).keys()]
                .slice(
                  Math.max(0, currentPage - 2),
                  Math.min(totalPages, currentPage + 1)
                )
                .map((page) => (
                  <Button
                    key={page + 1}
                    onClick={() => handlePageChange(page + 1)}
                    style={{
                      width: "40px",
                      height: "40px",
                      color: currentPage === page + 1 ? "white" : "#1f1f1f",
                      background:
                        currentPage === page + 1 ? "#3BABA6" : "#f5f5f5",
                      marginLeft: "10px",
                      marginRight: "10px",
                      borderRadius: "80px",
                      border: 0,
                    }}
                    className={currentPage === page + 1 ? "active" : ""}
                  >
                    {page + 1}
                  </Button>
                ))}
              <Button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  width: "40px",
                  height: "40px",
                  color: "#1f1f1f",
                  borderWidth: "1px",
                  borderColor:
                    currentPage === totalPages ? "#f5f5f5" : "#1f1f1f",
                  background: "#f5f5f5",
                  borderRadius: "80px",
                }}
              >
                &gt;
              </Button>
            </div>
          </div>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: "60px",
              position: "sticky",
              bottom: "0",
              zIndex: "10",
            }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default RedeemPasses;
